module.exports = __webpack_public_path__ + "images/renault8f7244b1e08afa2c1f2143ef4c6646df.png";